module.exports = __webpack_public_path__ + "static/media/Mekar Cipta Lestari.cda8e444.png";